import { Injectable } from '@angular/core';
import { TabCacheService } from './tab-cache.service';

@Injectable({
  providedIn: 'root'
})
export class TabTemplateInstanceCalculatorService {

  get tabs() {
    return this.tabsStorageService.tabs;
  }

  constructor(private tabsStorageService: TabCacheService) { }

  calculateInstances(tabTemplateName): number {
    return this.tabs
      .filter(t => t.templateName === tabTemplateName)
      .length;
  }
}
